/**
 * Update the steps in the component's state
 * state.steps is {Object[Boolean]} representing a complete or incomplete step
 * @returns {Function}
 */
export const sequenceStateUpdater = (component) => {
  return step => component.setState((state) => {
    let newSteps = { ...state.steps };
    newSteps[step.label] = true;
    return { ...state, steps: { ...newSteps } };
  });
};